import { render, staticRenderFns } from "./VeHrPerformanceWeek.vue?vue&type=template&id=2e8854d8&scoped=true"
import script from "./VeHrPerformanceWeek.vue?vue&type=script&lang=js"
export * from "./VeHrPerformanceWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8854d8",
  null
  
)

export default component.exports